export const SWAP_WIDGET_URL = 'https://iframe.jumper.exchange/swap'

export const SWAP_TITLE = 'Safe Swap'
export const SWAP_ORDER_TITLE = 'Swap order'
export const LIMIT_ORDER_TITLE = 'Limit order'
export const TWAP_ORDER_TITLE = 'TWAP order'

export const SWAP_FEE_RECIPIENT = '0xE344241493D573428076c022835856a221dB3E26'
